export default __webpack_public_path__ + "static/media/fast-car.2895c7fe.svg";